<!--
 * @Author: leo.liu
 * @Date: 2021-3-13 11:04:24
 * @Last Modified by:   leo.liu
 * @Last Modified time: 2021-3-13 11:04:24
 !-->
<template>
  <div>    
    <draggable
      :step="step"
      :position="widgetsPosition"
      ref="draggable"
      :index="index"
      :z-index="-1"
      @blur="handleChange"
    >
      <!-- <keep-alive>
      </keep-alive> -->
        <component :key="index" :comp-index="index" :is="type" :value="value" :widgetValueChanged="widgetValueChanged" :option="options" @change="timeChange" />
    </draggable>
    <div class="check-mask" :style="{
      width: widgetsPosition.width + 'px',
      height: widgetsPosition.height + 'px',
      left: widgetsPosition.left + 'px',
      top: widgetsPosition.top + 'px',
      zIndex: -1
    }" v-if="batchFlag">
      <a-checkbox @change="checkChange" :checked="checkValue" class="checkbox"></a-checkbox>
    </div>
  </div>
</template>

<script>
import widgetHref from "./widgetHref.vue";
import widgetCard from "./widgetCard.vue";
import widgetText from "./widgetText.vue";
import widgetButton from "./widgetButton.vue";
import widgetTextFilter from "./widgetTextFilter.vue";
import WidgetMarquee from "./widgetMarquee.vue";
import widgetTime from "./widgetTime.vue";
import widgetFilter from "./widgetFilter.vue";
import widgetImage from "./widgetImage.vue";
import widgetSlider from "./widgetSlider.vue";
import widgetVideo from "./widgetVideo.vue";
import WidgetIframe from "./widgetIframe.vue";
import widgetBarchart from "./bar/widgetBarchart.vue";
import widgetGradientColorBarchart from "./bar/widgetGradientColorBarchart.vue";
import widgetLinechart from "./line/widgetLinechart.vue";
import widgetBarlinechart from "./bar/widgetBarlinechart";
import WidgetPiechart from "./pie/widgetPiechart.vue";
import WidgetFunnel from "./widgetFunnel.vue";
import WidgetGauge from "./percent/widgetGauge.vue";
import WidgetPieNightingaleRoseArea from "./pie/widgetPieNightingaleRose";
import widgetTable from "./table/widgetTable.vue";
// import widgetMap from "./widgetMap.vue";
import widgetPiePercentageChart from "./percent/widgetPiePercentageChart";
// import widgetAirBubbleMap from "./map/widgetAirBubbleMap";
import widgetBarStackChart from "./bar/widgetBarStackChart";
import widgetLineStackChart from "./line/widgetLineStackChart";
import widgetBarCompareChart from "./bar/widgetBarCompareChart";
import widgetLineCompareChart from "./line/widgetLineCompareChart";
import widgetDecoratePieChart from "./decorate/widgetDecoratePieChart";
import widgetMoreBarLineChart from "./bar/widgetMoreBarLineChart";
// import widgetWordCloud from "./wordcloud/widgetWordCloud";
import draggable from "../components/draggable";

export default {
  name: "Widget",
  components: {
    widgetHref,
    widgetCard,
    widgetText,
    WidgetMarquee,
    widgetTime,
    widgetButton,
    widgetTextFilter,
    widgetFilter,
    widgetImage,
    widgetSlider,
    widgetVideo,
    WidgetIframe,
    widgetBarchart,
    widgetGradientColorBarchart,
    widgetLinechart,
    widgetBarlinechart,
    WidgetPiechart,
    WidgetFunnel,
    WidgetGauge,
    WidgetPieNightingaleRoseArea,
    widgetTable,
    // widgetMap,
    widgetPiePercentageChart,
    // widgetAirBubbleMap,
    widgetBarStackChart,
    widgetLineStackChart,
    widgetBarCompareChart,
    widgetLineCompareChart,
    widgetDecoratePieChart,
    widgetMoreBarLineChart,
    draggable
    // widgetWordCloud
  },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    /*
    widget-text widget-marquee widget-href widget-time widget-image widget-slider widget-video widget-table widget-iframe widget-universal
    widget-linechart widget-barlinechart widget-piechart widget-hollow-piechart widget-funnel widget-gauge widget-china-map
    */
    index: Number, // 当前组件，在工作区变量widgetInWorkbench中的索引
    type: String,
    bigscreen: Object,
    value: {
      type: [Object],
      default: () => {},
    },
    options: {
      type: [Object, Array],
      default: () => {},
    },
    widgetValueChanged: Function,
    step: Number,
    batchFlag: Boolean,
    batchList: {
      type: [Array],
      default: () => [],
    },
    widgets: {
      type: [Array],
      default: () => [],
    },
    widgetIndex: {
      type: [Number],
      default: () => -1,
    }
  },
  data() {
    return {

    };
  },
  methods: {
    checkChange() {
      console.log(this.checkValue,this.batchList, [...this.batchList, this.index])
      this.$emit('batchListChange', this.checkValue?this.batchList.filter(v => v !== this.index):[...this.batchList, this.index])
    },
    timeChange(val) {
      this.$emit("timeChange", val);
    },
    handleChange({ index, left, top, width, height }) {
      console.log(index, left, top, "handleFocus");
      let bw = this.bigscreen.bigscreenWidth || 1200
      let w =  Math.round(width)
      let l = Math.round(left/20) * 20
      let t = Math.round(top/20) * 20
      l = l < 0?0:l
      l = (l + width) > bw?(bw - width):l
      l = Math.floor(l/20) * 20
      t = t < 0?0:t
      let obj = {
        index,
        left: l,
        top: t,
        width: w,
        height,
      }
      console.log(obj, '.............')
      if(this.widgetIndex !== index || JSON.stringify(this.value.position) !== JSON.stringify(obj)) {
        this.$emit("onActivated", obj)
        setTimeout(() => {
          this.$refs.draggable.init()
        }, 200)
      }
    },
  },
  computed: {
    widgetsPosition() {
      return {
        width: this.value.position?.width || 0,
        height: this.value.position?.height || 0,
        left: this.value.position?.left || 0,
        top: this.value.position?.top || 0,
      }
    },
    widgetsZIndex() {
      return this.value.position.zIndex || 1;
    },
    checkValue() {
      return this.batchList.indexOf(this.index) > -1
    }
  },
  watch: {
    'widgets.length': {
      handler(val) {
        this.$emit('batchListChange', [])
      },
      deep: true,
    }
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.vue-draggalbe {
  position: absolute;
}

.widget-active {
  cursor: move;
  border: 1px dashed #CBD5EE;
  background-color: rgba(115, 170, 229, 0.5);
}

.avue-draggable {
  padding: 0 !important;
  .avue-draggable__item{
    border-radius: 12px;
    border: 1px solid #CBD5EE;
  }
  .avue-draggable__mask{
    border-radius: 12px;
    border: 1px solid #CBD5EE;
  }
}
/deep/ .el-input.avue-draggable__focus{
  height: 100%;
  .el-input__inner {
    height: 100%;
  }
}
.check-mask {
  position: absolute;
  // background: #CBD5EE;
  .checkbox {
    font-size: 30px;
    position: absolute;
    right: -5px;
    top: -10px;
    /deep/ .ant-checkbox {
      border-radius: 50%;
      .ant-checkbox-inner {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        &::after {
          width: 15px;
          height: 25px;
        }
      }
      &::after {
        border-radius: 50%;
      }
    }
  }
}
</style>
